// Module
var code = "<div class=\"modal-header\"> <h3 class=\"modal-title\">Error</h3> </div> <div class=\"modal-body\"> Problems were encountered: <ul> <li ng-repeat=\"e in $ctrl.errors\"> {{e}} </li> </ul> {{$ctrl1 | json}} </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"$close()\">OK</button> </div>";
// Exports
module.exports = code;